import api from '@/services/api.js';
import qs from 'qs';

export default {
    getAllWherePortfolio(portfolioId, skipOwner){
        let query;
        if(skipOwner){    
            query = qs.stringify({ _where: [{ 'portfolio_id': portfolioId }, { 'is_owner': false } ] });
        }
        else query = qs.stringify({ _where: { 'portfolio_id': portfolioId } });

        return api.get(`/usertoaccess-grouptoportfolios?${query}`);
    },
    getAllWhereContact(contactId){
        const query = qs.stringify({ _where: { 'contact.id': contactId } });
        return api.get(`/usertoaccess-grouptoportfolios?${query}`);
    },  
    getAllWhereUserId(userId){
        const query = qs.stringify({ _where: { 'contact.user_id': userId } });
        return api.get(`/usertoaccess-grouptoportfolios?${query}`);
    },
    getOneWherePortfolioIdAndUserId(portfolioId, userId){  
        const query = qs.stringify({ _where: [{ 'portfolio_id': portfolioId}, {'contact.user_id': userId }] });
        return api.get(`/usertoaccess-grouptoportfolios?${query}`);
    },
    getOne(c2ag2pId) {
        return api.get('usertoaccess-grouptoportfolios/' + c2ag2pId);
    },
    add(c2ag2p){
        return api.post('usertoaccess-grouptoportfolios', c2ag2p);
    },
    update(contactToAccess){
        return api.put('usertoaccess-grouptoportfolios/' + contactToAccess.id, contactToAccess);
    },
    delete(c2ag2pId){
        return api.delete('/usertoaccess-grouptoportfolios/' + c2ag2pId);
    }
}